import { Feature, Point } from 'geojson';

import { SnBadgeConfig } from '@lib/ui/badge';

import { IBaseEsriMarkerOptions } from './base-marker-options';
import {
  IEsriMapNameIcon,
  IEsriMapFontIcon,
  IEsriMapFontIconUnicode,
} from './icon-marker-options';
import { EsriMarkerType } from './marker-types';

export interface IEsriMapMarkerStyleOptions {
  scale?: number;
  rotation?: number;
  fillColor?: string;
  fillOpacity?: number;
  strokeColor?: string;
  strokeWeight?: number;
  strokeOpacity?: number;
  url?: string;
  size?: { width: number; height: number };
  scaledSize?: { width: number; height: number };
}

export type EsriMapMarkerStyleOptions = IEsriMapMarkerStyleOptions;

export interface IEsriMapMarkerLabel {
  text: string;
  color?: string;
  display?: string;
  className?: string;
}

export interface IEsriMapMarkerIconOptions {
  color?: string;
  url?: string;
}

export interface IEsriMapMarkerIconLabel {
  text: string;
  top?: number;
  left?: number;
  color?: string;
  fontSize?: string;
  transform?: string;
  field?: string;
}

export type EsriMapMarkerIconLabel = IEsriMapMarkerIconLabel;

export type EsriMapMarkerIcon =
  | string
  | (IEsriMapNameIcon & IEsriMapMarkerIconOptions)
  | (IEsriMapFontIcon & IEsriMapMarkerIconOptions)
  | (IEsriMapFontIconUnicode & IEsriMapMarkerIconOptions);

export interface IEsriMapMarkerOptions extends IBaseEsriMarkerOptions {
  image?: any;
  icon?: EsriMapMarkerIcon;
  iconLabel?: IEsriMapMarkerIconLabel;
  type?: EsriMarkerType;
  badge?: SnBadgeConfig;
  style?: IEsriMapMarkerStyleOptions;
  label?: string | IEsriMapMarkerLabel;
  draggable?: boolean;
  feature?: Feature<Point>;
}
